import React from 'react'

import {
  HomeSearchFormContainer,
  HomeSearchFormInput,
  HomeSearchFormDivider,
  HomeSearchFormButton,
} from './HomeSearch.styled'
import Button from 'components/Button/Button'
import { useHistory } from 'react-router-dom';

const HomeSearchForm = () => {
  const { push } = useHistory()
  
  return (
    <HomeSearchFormContainer>
      <Button
        text="Sign up"
        variant="primary"
        preset="ghost"
        size={'large'}
        onClick={() => push('/sign-up')}
      />
      {/*       <HomeSearchFormInput type="text" placeholder="Facility or Town" />
      <HomeSearchFormDivider />
      <HomeSearchFormButton type="submit">LET’ PLAY</HomeSearchFormButton> */}
    </HomeSearchFormContainer>
  )
}

export default HomeSearchForm
